import { render, staticRenderFns } from "./menuBadgeRefreshDialog.vue?vue&type=template&id=455e44ef"
import script from "./menuBadgeRefreshDialog.vue?vue&type=script&lang=js"
export * from "./menuBadgeRefreshDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports